import React, { useEffect } from 'react'
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import BucketFilled from '../../Assetes/Images/kfc-basket.png'
import MyDetail from './MyDetail';
import AddFavourite from './AddFavourite';
import OrderHistory from './OrderHistory';
import SaveAddress from './SaveAddress';
import Header from '../../Components/Header';
import { useTranslation } from 'react-i18next';
import Footer from '../../Components/Footer';



export default function ProfilePage() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { t } = useTranslation();

    return (
        <>
            <Header />
            <section className='mt-100'>
                <div className="container">
                    <div className="profile-page mb-5">
                        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                            <Row>
                                <Col md={3}>
                                    <Nav variant="pills" className="flex-column profile-tab">

                                        <Nav.Item>
                                            <Nav.Link className='profile-tab-btn mb-2' eventKey="first">{t("MY_DETAILS")}</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link className='profile-tab-btn mb-2' eventKey="3"> {t("SAVED_VOUCHERS")}</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link className='profile-tab-btn mb-2' eventKey="4">{t("FAVOURITE_ITEMS")}</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link className='profile-tab-btn mb-2' eventKey="5">{t("ADDRESS")}</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link className='profile-tab-btn mb-2' eventKey="6">{t("ORDER_HISTORY")}</Nav.Link>
                                        </Nav.Item>


                                    </Nav>
                                </Col>
                                <Col className='pl-0' md={9}>
                                    <Tab.Content className='profile-tab'>

                                        <Tab.Pane eventKey="first">
                                            <MyDetail />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="3">
                                            <img src={BucketFilled} className='w-25' alt="" />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="4">
                                            <AddFavourite />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="5">
                                            <SaveAddress />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="6">
                                            <OrderHistory />
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}
